module.exports = __webpack_public_path__ + "static/ethcc2-1-a190c4baa2cf472154d56a0163491063.png";